/* eslint-disable react/no-array-index-key */

import React, { memo } from 'react';
import useContactMessageData from '../../../hooks/inbox/data/useContactMessageData';
import MessageStatusMC from './MessageStatusMC';
import ContactMC from './ContactMC';

/**
 * ContactMessageMC
 * Componente optimizado y desacoplado según arquitectura Mercately.
 * - Usa hooks especializados para lógica de datos y UI.
 * - Aplica TailwindCSS y React.memo para máximo rendimiento.
 */
const ContactMessageMC = memo(({ conversation, message }) => {
  const { contacts } = useContactMessageData(message);

  return (
    <div
      id={`contact-message-${message?.id}`}
      className="tw-wrapper"
      data-testid="ContactMessageMC"
    >
      {contacts.map((contact, index) => (
        <div
          key={`${message.id}-${index}`}
          className="tw-p-3 tw-mb-2 tw-cursor-pointer tw-text-sm tw-font-normal"
        >
          <ContactMC contact={contact} />
        </div>
      ))}
      <MessageStatusMC message={message} platform={conversation.platform} />
    </div>
  );
});

ContactMessageMC.displayName = 'ContactMessageMC';

export default ContactMessageMC;
